module.exports = __webpack_public_path__ + "static/shape2-f4b9817e0beb4a670fb37d1d273d1407.png";